import { createPortal } from 'react-dom'
import CampaignEmailCustomizationSection from 'features/EmailEditor/CampaignEmailCustomizationSection'
import EmailPreview from 'features/EmailEditor/EmailPreview'
import TestEmail from 'features/EmailEditor/TestEmail'
import { useEmailEditor } from 'features/EmailEditor/EmailEditorContext'
import { getCampaignTitle } from 'features/ManageCampaigns/utils/getCampaignTitle'
import { useEffect, useRef } from 'react'

import styles from './EditTextDialog.module.scss'

const CampaignEmailVariantSaveRegistrar = ({ contentId, onRegister }) => {
  const { saveChanges, hasUnsavedChanges, refreshEmailData } = useEmailEditor()
  const editorRef = useRef({ saveChanges, hasUnsavedChanges, refreshEmailData })

  editorRef.current = { saveChanges, hasUnsavedChanges, refreshEmailData }

  useEffect(() => {
    const editorApi = {
      get hasUnsavedChanges() {
        return editorRef.current.hasUnsavedChanges
      },
      saveChanges: (...args) => editorRef.current.saveChanges(...args),
      refreshEmailData: (...args) => editorRef.current.refreshEmailData(...args)
    }

    onRegister(contentId, editorApi)

    return () => {
      onRegister(contentId, null)
    }
  }, [contentId, onRegister])

  return null
}

const CampaignEmailVariantPreviewPortal = ({ previewPortalTarget, isFocused }) => {
  const emailEditor = useEmailEditor()

  if (!isFocused || !previewPortalTarget || !emailEditor) {
    return null
  }

  return createPortal(
    <div className={styles.emailPreviewAside}>
      <EmailPreview
        holderClassName={styles.inviteEmailPreviewHolder}
        testHolderClassName={styles.inviteEmailTestHolder}
        skipInitialSectionReset
        hideEditContentButton
        isEditable={false}
      >
        <TestEmail />
      </EmailPreview>
    </div>,
    previewPortalTarget
  )
}

const CampaignEmailVariantSection = ({
  campaign,
  isFocused,
  previewPortalTarget,
  onFocus,
  onRegister
}) => {
  return (
    <div className={styles.editTextForm} onFocusCapture={onFocus}>
      <p className={styles.editTextFormTitle}>{getCampaignTitle(campaign)}</p>
      <CampaignEmailVariantSaveRegistrar contentId={campaign.contentId} onRegister={onRegister} />
      <CampaignEmailCustomizationSection includeInboxFields={false} />
      <CampaignEmailVariantPreviewPortal
        previewPortalTarget={previewPortalTarget}
        isFocused={isFocused}
      />
    </div>
  )
}

export default CampaignEmailVariantSection
